import { render } from "./ClusterKubeVersion.vue?vue&type=template&id=50a2d46f"
import script from "./ClusterKubeVersion.vue?vue&type=script&lang=js"
export * from "./ClusterKubeVersion.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__